import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=33cb923c&scoped=true&"
import script from "./Insights.vue?vue&type=script&lang=ts&"
export * from "./Insights.vue?vue&type=script&lang=ts&"
import style0 from "./Insights.vue?vue&type=style&index=0&id=33cb923c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb923c",
  null
  
)

export default component.exports